<template>
    <v-alert v-if="!loading && paymentsReady && !stripeReady && paymentsModule != 'easypay'" elevation="0"
        color="#FFF8E1" dense class="text-center" :style="isDarkMode() ? { border: '1px solid #FFCC80', background: 'rgba(255, 204, 128, 0.1) !important' }:{border: '1px solid #FFCC80'}">
        <v-row class="d-flex align-center justify-center">
            <v-col cols="12" md="auto" class="d-flex align-center justify-center" style="gap: 12px">
                <v-icon size="20" color="plusAmberDarken4">mdi-information-outline</v-icon>
                <span class="font-roboto text-body-1 text-left" @click="$emit('show-connect-dialog')">
                    {{ $t('message.transactions_admin_plus.payment_connection_alert_message') }}
                </span>
            </v-col>

            <v-col cols="12" md="auto" class="d-flex align-center">
                <PlusButton small block intent="primary" @click="$emit('connect-payments')">
                    <span class="font-roboto text-button">{{
                        $t('message.transactions_admin_plus.payment_connection_connect_stripe') }}</span>
                </PlusButton>
            </v-col>
        </v-row>
    </v-alert>
</template>

<script>
import PlusButton from "@/components/plus/PlusButton.vue";

export default {
    name: 'PaymentConnectionAlert',
    components: {
        PlusButton,
    },
    props: {
        loading: {
            type: Boolean,
            required: true
        },
        paymentsReady: {
            type: Boolean,
            required: true
        },
        stripeReady: {
            type: Boolean,
            required: true
        },
        paymentsModule: {
            type: String,
            required: true
        }
    },
    emits: ['show-connect-dialog', 'connect-payments']
}
</script>
